/**
 * Created by jiachenpan on 16/11/18.
 */

export function isvalidUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export function validateAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * 特殊字符串
 * @param str
 * @returns {boolean}
 */
export function validateSpecial(str) {
  // const reg = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、,Null,null,&nbsp]/im;
  const reg = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]");
  return reg.test(str)
}

/**
 * 验证数字
 * @param val
 * @returns {boolean}
 */
export function validateNumber(val) {
  const reg = /^\d+$/
  return reg.test(val)
}

/**
 * 验证是否为图片
 * @param val
 * @returns {boolean}
 */
export function validateImg(val) {
  const reg = /(.jpg|.jpeg|.gif|.png|.bmp)$/
  return reg.test(val.toLowerCase())
}

/**
 * 验证中文
 */
export function validateChinese(val) {
  const reg = /[\u4e00-\u9fa5]/im
  return reg.test(val)
}

/**
 * 验证身份证ID
 * @param val
 * @returns {boolean}
 */
export function validateChineseID(val) {
  const reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
  return reg.test(val)
}

/**
 * 去掉html代码
 * @param val
 */
export function removeHtml(val){
  let reg=/<\/?.+?\/?>/g;
  return val.replace(reg,'')
}

/**
 * 去掉前后空格
 * @param val
 */
export function trim(val){
  return val.replace(/(^\s*)|(\s*$)/g, "");  
}